import cn from 'classnames';

import { useDictionary } from 'src/hooks/useDictionary';

import LinksGridSection from 'components/BaseHelpers/LinksGridSection';
import StartIndex from 'components/BaseHelpers/StartIndex';
import StopIndex from 'components/BaseHelpers/StopIndex';

import { ComponentProps } from '../../../types/component-props';
import { CoreCrossLinksGridData } from '../../../types/components';

import styles from './CoreCrossLinksGrid.module.scss';

export type CoreCrossLinksGridProps = ComponentProps & CoreCrossLinksGridData;

const CoreCrossLinksGrid = (props: CoreCrossLinksGridProps): JSX.Element => {
  const { heading, description, links, displayCount, showAll, jumpLinkLabel } = props.fields;

  const { showAllLabel } = useDictionary();

  if (links.length === 0) {
    return <></>;
  }

  return (
    <>
      <StopIndex />
      <div className={cn(styles.main)}>
        <LinksGridSection
          heading={heading}
          description={description}
          links={links}
          showAll={showAll}
          displayCount={displayCount}
          showAllLabel={showAllLabel}
          jumpLinkLabel={jumpLinkLabel}
        />
      </div>
      <StartIndex />
    </>
  );
};

export default CoreCrossLinksGrid;
